// helpers
import { getWindowLocale } from './locale';
//////////////////////////////////////////////////

const createCommonModalOptions = (modalContent) => ({
  p: '0',
  component: modalContent,
  options: { width: 'auto', height: 'auto' },
});

const createAddReferenceModalOptions = (modalContent) => ({
  p: 15,
  component: modalContent,
  options: {
    width: 300,
    height: 'auto',
    title: getWindowLocale('titles:add-reference', 'Add Reference'),
  },
});

const getDefaultModalOptions = (
  component,
  title,
) => ({
  p: 15,
  component,
  options: {
    title,
    width: 300,
    height: 'auto',
    overflow: 'initial',
  },
});

const getDefaultModalOptions2 = (
  component,
  title,
) => ({
  p: 15,
  component,
  options: {
    title,
    width: 445,
    height: 'auto',
    overflow: 'initial',
  },
});

const getNotMovableModalOptions = (
  component,
  title,
) => ({
  p: 15,
  component,
  options: {
    title,
    width: 300,
    height: 'auto',
    movable: false,
  },
});

const getRateModalWithContent = (component) => ({
  p: '0',
  component,
  options: {
    height: 'auto',
    overflow: 'auto',
    maxWidth: '95vw',
    maxHeight: '90vh',
    backgroundColor: 'none',
  },
});

const getConfirmDeleteModal = (component, action) => ({
  component,
  options: {
    width: 600,
    controlButtons: [
      {
        action,
        type: 'button',
        name: getWindowLocale('actions:delete', 'Delete'),
      },
    ],
  },
});

const getFullWindowModalWithContent = (component) => ({
  p: '0',
  component,
  options: {
    movable: false,
    width: '100vw',
    height: '100vh',
  },
});

const getFullWindowModalWithContentWithLeftSpace = (component, leftSpaceWidth) => ({
  p: '0',
  component,
  options: {
    height: '100dvh',
    left: leftSpaceWidth || 'initial',
    width: `calc(100vw - ${leftSpaceWidth || 0}px)`,
  },
});

const getDrawerModalWithContentRightPlacement = (component, width, options) => ({
  p: '0',
  component,
  options: {
    width,
    height: '100dvh',
    left: `calc(100vw - ${width}px)`,
    ...options,
  },
});

const getFullWindowModalPropsWithLeftSpace = (leftSpaceWidth) => ({
  p: '0',
  options: {
    height: '100vh',
    left: leftSpaceWidth || 'initial',
    width: `calc(100vw - ${leftSpaceWidth || 0}px)`,
  },
});

const getFullWindowModalWithContentCalculated = (component, calcWidth, calcHeight) => ({
  p: '0',
  component,
  options: {
    width: `calc(100vw - ${calcWidth || 0}px)`,
    height: `calc(100vh - ${calcHeight || 0}px)`,
  },
});

export {
  getConfirmDeleteModal,
  getDefaultModalOptions,
  getDefaultModalOptions2,
  getRateModalWithContent,
  createCommonModalOptions,
  getNotMovableModalOptions,
  getFullWindowModalWithContent,
  createAddReferenceModalOptions,
  getFullWindowModalPropsWithLeftSpace,
  getDrawerModalWithContentRightPlacement,
  getFullWindowModalWithContentCalculated,
  getFullWindowModalWithContentWithLeftSpace,
};
